import axios from "axios"
import Image from "next/image"
import { useCallback, useEffect, useState } from "react"

import { Box } from "components/shared/box"
import { Rotating } from "components/shared/icons/rotating"
import { Button } from "components/shared/landing/button"
import { Text } from "components/shared/text"

const metaUrl = "https://ipfs.io/ipfs/Qmf9X9584Yb4KAGwwRN9d9B9cuWoZqnEF7mqMsJ9j2KNaX"
const genesisMetaUrl = "https://functions.cryptobots.me"

type BotMeta = {
  image: string
  background_color: string
}

type BotMetaGenesis = [
  {
    meta: {
      image: string
    }
  },
]

type Props = {
  id: number
  blockchainApproved: boolean
  approve?: (id: number) => Promise<void>
  wrap?: (id: number) => Promise<void>
  onSelect: (id: number) => void
  selected: boolean
  showButtons?: boolean
  isGenesis?: boolean
}

export const BotCard = ({
  id,
  approve,
  wrap,
  blockchainApproved,
  selected,
  onSelect,
  showButtons = true,
  isGenesis = false,
}: Props) => {
  const [metaLoading, setMetaLoading] = useState(false)
  const [approved, setApproved] = useState(blockchainApproved)
  const [processing, setProcessing] = useState(false)
  const [img, setImg] = useState("")

  const handleApprove = useCallback(async () => {
    setProcessing(true)
    try {
      await approve?.(id)
      setApproved(true)
    } catch (error) {}
    setProcessing(false)
  }, [])

  const handleWrap = useCallback(async () => {
    setProcessing(true)
    try {
      await wrap?.(id)
    } catch (error) {}
    setProcessing(false)
  }, [])

  useEffect(() => {
    setMetaLoading(true)
    const getMeta = async () => {
      try {
        if (isGenesis) {
          const response = await axios.get<BotMetaGenesis>(`${genesisMetaUrl}/meta?ids=[${id}]`)
          setImg(response?.data?.[0]?.meta?.image || "")
        } else {
          const response = await axios.get<BotMeta>(`${metaUrl}/${id}`)
          setImg(response?.data?.image || "")
        }
      } catch (error) {
        console.log("err", error)
      }
      setMetaLoading(false)
    }
    getMeta()
  }, [])

  const handleSelect = () => {
    if (!approved) {
      return
    }
    onSelect(id)
  }

  return (
    <Box
      className={`transition duration-150 ease-out relative p-2 rounded-md backdrop-blur-md bg-white/10 gap-2 border-[2px] border-[#ffffff00] ${
        selected ? "border-[#ff46aa] scale-[0.98]" : ""
      }`}
    >
      <Text className="text-tiny text-center opacity-80"># {id}</Text>
      <Box className="rounded-md overflow-hidden" onClick={handleSelect}>
        {metaLoading ? (
          <Box center className="w-[220px] h-[220px]">
            <Rotating className="animate-spin w-[2rem]" />
          </Box>
        ) : (
          <Image height={220} width={220} src={img || "/images/shared/game/bot-platform/bot_empty.png"} alt="bot" />
        )}
      </Box>
      {showButtons && (
        <Box center className="py-2">
          {!metaLoading && (
            <Button
              size="sm"
              type="secondary"
              className="w-[180px] uppercase"
              loading={processing}
              onClick={approved ? handleWrap : handleApprove}
            >
              {approved ? "Wrap" : "Approve"}
            </Button>
          )}
        </Box>
      )}
    </Box>
  )
}
